import React from 'react';
import { Modal } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import OverlayScreen from '@vfgroup-oneplatform/foundation/Components/OverlayScreen';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import VFLottieView from '@vfgroup-oneplatform/foundation/Components/VFLottieView';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import styles from './UpgradeDeviceSuccessModal.Styles';

const UpgradeDeviceSuccessModal = ({
  isVisible,
  selectedPlanName,
  selectedDeviceName,
  deliveryDate,
  userName,
  onDeviceUpgradeSuccessActionPress,
}) => {
  const theme = useTheme();
  const firstSubTitle = ContentManager.translate(
    'device_upgrade_summary_confirm_success_first_subtitle',
    [selectedPlanName, selectedDeviceName, deliveryDate],
  );
  const headerKey = ContentManager.translate('device_upgrade_summary_confirm_success_title', [
    userName,
  ]);
  return (
    <Modal visible={isVisible}>
      <OverlayScreen
        containerStyle={{ backgroundColor: theme.colors.backgroundColorFive }}
        renderCustomImage={() => (
          <VFLottieView type={'tick'} autoPlay={true} loop={false} style={styles.lottiStyle} />
        )}
        renderContent={() => {
          return (
            <VFText
              type={'primary'}
              i18nKey={'device_upgrade_summary_confirm_success_second_subtitle'}
              style={[styles.subTitle, styles.secondSubTitle]}
            />
          );
        }}
        visible={true}
        hasSingleButton
        descriptionKey={firstSubTitle}
        headerKey={headerKey}
        vfTextDescriptionProps={{ type: 'primary', style: styles.subTitle }}
        onProceed={onDeviceUpgradeSuccessActionPress}
        okButtonText={'device_upgrade_summary_confirm_success_button_title'}
      />
    </Modal>
  );
};
UpgradeDeviceSuccessModal.propTypes = {
  isVisible: PropTypes.bool,
  selectedPlanName: PropTypes.string,
  selectedDeviceName: PropTypes.string,
  deliveryDate: PropTypes.string,
  userName: PropTypes.string,
  onDeviceUpgradeSuccessActionPress: PropTypes.func,
};
export default UpgradeDeviceSuccessModal;
